import { Component, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseTooltip } from 'shared/abstract/base-tooltip';
import {
    IMAGE_TRACKER_LISTING_ERRORS_TRANSLATIONS,
    IMAGE_TRACKER_LISTING_WARNINGS_TRANSLATIONS,
    ImageTrackerListingError,
    ImageTrackerListingWarning,
} from 'visuals/interfaces/visuals-image-tracker.interface';

@Component({
    selector: 'app-image-tracker-status-tooltip',
    imports: [TranslatePipe],
    templateUrl: './image-tracker-status-tooltip.component.html',
    styleUrl: './image-tracker-status-tooltip.component.scss',
})
export class ImageTrackerStatusTooltipComponent extends BaseTooltip implements OnInit {
    readonly ERROR_TRANSLATIONS = IMAGE_TRACKER_LISTING_ERRORS_TRANSLATIONS;
    readonly WARNING_TRANSLATIONS = IMAGE_TRACKER_LISTING_WARNINGS_TRANSLATIONS;

    public override data: any;

    readonly errorCodes = signal<ImageTrackerListingError[]>([]);
    readonly warningCodes = signal<ImageTrackerListingWarning[]>([]);

    ngOnInit(): void {
        this.errorCodes.set(this.data.errors);
        this.warningCodes.set(this.data.warnings);
    }
}
